import { Link } from "react-router-dom";
import { siteIntro } from "@/mocks/site";

export default function PlatformIntro() {
  return (
    <section className="bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-900/25 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-leaf-line"></i>
              关于榴莲视频
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              好的故事，<span className="text-accent-500">值得被更多人看见</span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">
              {siteIntro.description}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line"></i>
                了解我们
              </Link>
              <Link
                to="/news"
                className="flex items-center gap-2 rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-newspaper-line"></i>
                阅读资讯
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 animate-fade-up delay-2">
            {siteIntro.stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg border border-background-200/60 bg-background-50/60 p-5 md:p-6"
              >
                <p className="font-heading text-2xl font-bold text-accent-500 md:text-3xl">{s.value}</p>
                <p className="mt-1 text-sm text-foreground-400">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}